import { useState } from 'react';

import Button from '@components/Button';
import LoginForm from '@components/LoginForm';

const EmbeddedLoginView = ({ isIframe }: { isIframe: boolean }) => {
    const [showLogin, setShowLogin] = useState(false);

    if (isIframe)
        return (
            <div className="container flex max-w-lg flex-col items-center justify-center space-y-4 p-4 text-center">
                <img src="/images/logos/Pluto_Bio_Logo.svg" alt="Pluto Bio Logo" className="h-10" />
                <p>
                    No active account detected. Please login to Pluto in another tab, then refresh to view this content.
                </p>
            </div>
        );

    return (
        <div className="container max-w-lg p-4">
            {showLogin ? (
                <div className="space-y-8">
                    <div className="flex justify-center">
                        <img src="/images/logos/Pluto_Bio_Logo.svg" alt="Pluto Bio Logo" className="h-10" />
                    </div>
                    <LoginForm />
                </div>
            ) : (
                <div className="flex flex-col items-center justify-center space-y-4 py-12">
                    <div className="flex justify-center">
                        <img src="/images/logos/Pluto_Bio_Logo.svg" alt="Pluto Bio Logo" className="h-14" />
                    </div>
                    <p>
                        You must be logged into{' '}
                        <a href="https://app.pluto.bio/login" target="_blank" rel="noreferrer">
                            Pluto Bio
                        </a>{' '}
                        to view this content.
                    </p>
                    <Button onClick={() => setShowLogin(true)} variant="contained" color="primary">
                        Sign in to Pluto
                    </Button>
                </div>
            )}
        </div>
    );
};

export default EmbeddedLoginView;
